import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Snackbar } from "@core/material";
import { EditorChangeContent, EditorChangeSelection } from "ngx-quill";
import { Subject } from "rxjs";
import { FONT_FAMILY_OPTIONS } from "@core/data/types/advanced-report";
import { FontLoaderService } from "@core/fonts/font-loader.service";

export interface ReportTextEditFormDialogData {
    content: string;
}

@Component({
    selector: 'pv-report-text-edit-form-dialog',
    templateUrl: 'report-text-edit-form.dialog.html',
    styleUrls: ['report-text-edit-form.dialog.scss'],
    preserveWhitespaces: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportTextEditFormDialog implements OnInit, OnDestroy {

    contentControl: FormControl = new FormControl(null);

    formGroup: FormGroup = new FormGroup({
        content: this.contentControl,
    })

    // Editor toolbar — the full default Quill action set, with the font dropdown swapped to the report
    // families (registered on Quill in the module). Nothing from the original toolbar is dropped.
    editorModules = {
        toolbar: [
            [{ font: FONT_FAMILY_OPTIONS }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ color: [] }, { background: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ align: [] }],
            ['link', 'image', 'video'],
            ['clean'],
        ],
    };

    private _destroy$ = new Subject();

    blurred: boolean = false
    focused: boolean = false

    constructor(
        private _dialogRef: MatDialogRef<ReportTextEditFormDialogData>,
        @Inject(MAT_DIALOG_DATA) private _data: ReportTextEditFormDialogData,
        private _snackbar: Snackbar,
        private _fontLoader: FontLoaderService,
    ) {}

    ngOnInit() {
        this.formGroup.reset({
            content: this._data.content,
        })

        this.formGroup.enable()

        // Load every selectable family so the dropdown previews and editor render them correctly.
        FONT_FAMILY_OPTIONS.forEach(family => this._fontLoader.ensure(family));
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    attempt() {
        this.formGroup.updateValueAndValidity();
        this.formGroup.markAsDirty();

        if (this.formGroup.valid) {
            this._dialogRef.close({status: true, data: this.formGroup.value});

        } else {
            this._snackbar.formInvalid();
        }

    }

    cancel() {
        this._dialogRef.close({status: false});
    }

}